
<template>
    <div>
        <!-- ------------------------------------------
                        kits_combinations
        ----------------------------------------------->
        <div v-if="modalToShow === 'kits_combinations'">
            <b-modal
                ref="def_modal"
                id="id_def_modal"
                size="lg"
                centered
                hide-footer
                @hide="onHide"
            >
                <template slot="modal-title">{{ title }}</template>

                <div id="modal_content" class="m-2">
                    <div v-if="message !== ''" class="d-block text-center">
                        <h5 class="mb-4">{{ message }}</h5>
                    </div>

                    <div
                        v-if="html_message !== ''"
                        class="modal-body mb-4"
                        v-html="html_message"
                    ></div>

                    <b-button
                        v-if="showConfirmationButton"
                        class="mb-3"
                        variant="outline-success"
                        block
                        @click="sendModalResult('modal_confirmed')"
                        >{{ textConfirmationButton }}</b-button
                    >
                </div>
            </b-modal>
        </div>

        <div v-else>
            <!-- <b-modal ref="def_modal" @hide="onHide" :no-close-on-backdrop="false" id="id_def_modal" centered hide-footer> -->
            <b-modal ref="def_modal" @hide="onHide" id="id_def_modal" centered hide-footer>
                <template slot="modal-title">{{ title }}</template>

                <div id="modal_content" class="m-2">
                    <div v-if="message !== ''" class="d-block text-center">
                        <h5 class="mb-4">{{ message }}</h5>
                    </div>

                    <div
                        v-if="html_message !== ''"
                        class="modal-body mb-4"
                        v-html="html_message"
                    ></div>

                    <!-- ------------------------------------------
                        saveCurrenConfig
                    ----------------------------------------------->
                    <div v-if="modalToShow === 'saveCurrentConfig'"></div>

                    <!-- ------------------------------------------
                        warnPageLeaveModal
                    ----------------------------------------------->
                    <div v-if="modalToShow === 'warnPageLeaveModal'"></div>

                    <!-- ------------------------------------------
                        conexionError
                    ----------------------------------------------->
                    <div v-if="modalToShow === 'conexionError'"></div>

                    <!-- ------------------------------------------
                            showAccesDenied
                    ----------------------------------------------->
                    <div v-if="modalToShow === 'showAccesDenied'">
                        <div @click="app.auth.login()" class="mb-4 text-center">
                            <!-- <img src="images/login.png" class="loginIcon"> -->
                            <button
                                class="btn btn-success loginButton"
                                data-dismiss="modal"
                                data-bs-dismiss="modal"
                            >
                                {{ $t("register_login") }}
                            </button>
                        </div>
                    </div>
                    <!-- ------------------------------------------
                            EXPORT EXCEL / PDF
                    ----------------------------------------------->
                    <div v-if="modalToShow === 'showExportBOM'">
                        <div class="text-center mb-4">
                            <div class="iconsContainer">
                                <img
                                    @click="send_list_BOM('pdf')"
                                    src="images/p4/pdf.png"
                                    class="downloadBOMIcon"
                                    alt
                                    data-bs-dismiss="modal"
                                    data-dismiss="modal"
                                />

                                <img
                                    @click="send_list_BOM('excel')"
                                    src="images/p4/excel.png"
                                    class="downloadBOMIcon"
                                    alt
                                    data-bs-dismiss="modal"
                                    data-dismiss="modal"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- ------------------------------------ -->

                    <!-- style="max-width:300px" -->
                    <b-button
                        v-if="showConfirmationButton"
                        class="mb-3"
                        variant="outline-dark"
                        block
                        @click="sendModalResult('modal_confirmed')"
                        >{{ textConfirmationButton }}</b-button
                    >

                    <!-- style="max-width:300px" -->
                    <!-- variant="outline-secondary" -->
                    <b-button
                        v-if="showCancelButton"
                        variant="outline-dark"
                        block
                        @click="sendModalResult('modal_rejected')"
                        >{{ textCancelButton }}</b-button
                    >
                </div>
            </b-modal>
        </div>
    </div>
</template>

<style scoped lang="scss">
.downloadBOMIcon {
    height: 70px;
    margin: 15px;
    width: auto;
}
.modalBody {
    padding: 20px;
}

#id_def_modal___BV_modal_outer_ {
    z-index: 1100 !important;
}
</style>

<script>
import jQuery from "jquery";
import { app } from "../application.js";
let $ = jQuery;

export default {
    name: "modalComponent",
    data() {
        return {
            app: app,
            modalResult: "",
            modalToShow: "",
            title: "",
            message: "",
            html_message: "",
            text_message: "",
            showConfirmationButton: "",
            showCancelButton: "",
            textConfirmationButton: "",
            textCancelButton: "",
        };
    },
    beforeDestroy() {
        (this.modalResult = ""),
            (this.modalToShow = ""),
            (this.title = ""),
            (this.message = ""),
            (this.html_message = ""),
            (this.text_message = ""),
            (this.showConfirmationButton = false),
            (this.showCancelButton = false),
            (this.textConfirmationButton = ""),
            (this.textCancelButton = "");
    },

    methods: {
        onHide(evt) {
            if (evt.trigger === "backdrop") {
                // evt.preventDefault();
                this.$emit("user_clicked_backdrop");
                //this.handleBackdrop();
            }
        },

        // handleBackdrop() {
        //     console.log("Backdrop clicked");
        // },

        sendModalResult: function (nameEvent) {
            this.$emit(nameEvent);
        },

        showModal(infoModal) {
            let self = this;

            //set modal
            this.modalToShow = infoModal.modalToShow;
            this.title = infoModal.title;
            this.message = infoModal.message;
            this.html_message = infoModal.html_message;
            this.showConfirmationButton = infoModal.showConfirmationButton;
            this.showCancelButton = infoModal.showCancelButton;
            this.textConfirmationButton = infoModal.textConfirmationButton;
            this.textCancelButton = infoModal.textCancelButton;

            //show modal
            this.$refs["def_modal"].show();

            //al clicar al buto de enviar mail a Unex tanca modal
            $(function () {
                $("#asistencia_mailto, #asistencia_mailto_blank_field").on(
                    "click",
                    function (event) {
                        //espera 500ms abans de tancar modal
                        const espera = (temps_ms) =>
                            new Promise((resol) => setTimeout(resol, temps_ms));

                        espera(500)
                            .then(() => self.hideModal())
                            .catch();
                    }
                );
            });

            //return feedback from user and hide modal
            return new Promise(function (resolve, reject) {
                //llista de tots els possibles events emesos
                self.$on("modal_confirmed", () => {
                    resolve({
                        userAction: "modal_confirmed",
                        paramResult: self.paramResult,
                    });
                    self.hideModal();
                });

                self.$on("modal_rejected", () => {
                    resolve({ userAction: "modal_rejected", paramResult: "" });
                    //self.$root.$emit(nameEvent)
                    //resolve(self.modalResult);
                    self.hideModal();
                });

                //user clicks outside the modal
                self.$on("user_clicked_backdrop", () => {
                    //console.log('modal rejected backdrop');
                    resolve({ userAction: "modal_rejected_backdrop", paramResult: "" });
                    self.hideModal();
                });
            });
        },

        hideModal() {
            this.$refs["def_modal"].hide();
        },

        send_list_BOM: function (fileType) {
            //-----------------
            //test
            //-----------------
            if (fileType === "pdf") {
                this.app.downloadBOM("xlsx");
            } else if (fileType === "excel") {
                this.app.downloadBOM("pdf");
            }
            return;
            //-----------------

            if (this.userIsLoggedIn) {
                if (fileType === "pdf") {
                    this.app.downloadBOM("xlsx");
                } else if (fileType === "excel") {
                    this.app.downloadBOM("pdf");
                }
            } else {
                console.warn(
                    "Para descargar el BOM el usuario debe estar logeado!"
                );
            }
        },
    },
};
</script>